// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thunder"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 16.6397C3.81463 16.0724 3 14.8945 3 13.5333C3 11.8867 4.19223 10.5082 5.79079 10.1546C5.73117 9.84515 5.7 9.52608 5.7 9.2C5.7 6.35308 8.07582 4.04051 11.0224 4.00053C11.0482 4.00018 11.0741 4 11.1 4C11.5647 4 12.0157 4.05652 12.4459 4.16281C14.4933 4.66861 16.0716 6.30141 16.4254 8.33392C16.4502 8.33353 16.4751 8.33333 16.5 8.33333C17.3174 8.33333 18.0838 8.54318 18.7445 8.90998C18.9285 9.01218 19.1044 9.12656 19.2708 9.25199C20.3235 10.0451 21 11.2798 21 12.6667C21 14.4438 19.8891 15.9711 18.2995 16.6397","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11.4997 19L14.022 15H10.0215L12.4997 11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThunderIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thunder',
    ref,
    icon: element,
  },
));

ThunderIcon.displayName = 'ThunderIcon';

export default ThunderIcon;
